// extracted by mini-css-extract-plugin
export default {"BacktoTop":"BackToTop_BacktoTop__ajupL"};